/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpContextToken } from '@angular/common/http';
import { InjectionToken, makeStateKey } from '@angular/core';
import { CurrencyConfig } from '~core/models/currency.models';
import { PaymentMethod } from '~core/models/payment.models';

//Interceptors
export const SKIP_JWT_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

export const SKIP_ERROR_INTERCEPTOR = new HttpContextToken<boolean>(
  () => false
);

export const REMOTE_ENVIRONMENT_STATE_KEY =
  makeStateKey<Record<string, unknown>>('REMOTE_ENVIRONMENT');

export const REMOTE_ENVIRONMENT_INJECTION_TOKEN = new InjectionToken<
  Record<string, unknown>
>('REMOTE_ENVIRONMENT');

export const PREFERENCE_KEYS = {
  DOUBLE_FACTOR: 'security.authentication.double_factor',
  WATCHDOG: 'security.authentication.watchdog',
  ONBOARDING_CONSOLE_COMPLETED: 'onboarding.console_completed'
} as const;

export type SecurityPreferenceType = 'doubleFactor' | 'watchdog';

export const CURRENCY_MAP: Record<string, CurrencyConfig> = {
  XOF: {
    unitSingular: 'franc',
    unitPlural: 'francs',
    subUnitSingular: 'centime',
    subUnitPlural: 'centimes',
    suffix: 'CFA'
  },
  FCFA: {
    unitSingular: 'franc',
    unitPlural: 'francs',
    subUnitSingular: 'centime',
    subUnitPlural: 'centimes',
    suffix: 'CFA'
  },
  EUR: {
    unitSingular: 'euro',
    unitPlural: 'euros',
    subUnitSingular: 'centime',
    subUnitPlural: 'centimes'
  },
  USD: {
    unitSingular: 'dollar',
    unitPlural: 'dollars',
    subUnitSingular: 'cent',
    subUnitPlural: 'cents'
  }
};

export const DEFAULT_STICKER_NUMBERS: Record<string, string> = {
  [PaymentMethod.ORANGE_MONEY]: '+2250711111111',
  [PaymentMethod.MTN_MONEY]: '+2250511111111',
  [PaymentMethod.MOOV_MONEY]: '+2250111111111'
};
